import { useEffect, useState } from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { ProductsSection } from "@/components/ProductsSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { api } from "@/lib/api";

export default function Home() {
  const [products, setProducts] = useState(null);

  useEffect(() => {
    api
      .get("/products")
      .then((r) => setProducts(r.data))
      .catch(() => setProducts([]));
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#F8FAFC] text-[#0F172A]">
      <Navbar />
      <Hero />
      <Marquee />
      <ProductsSection products={products || []} />
      <ContactSection products={products || []} />
      <Footer products={products || []} />
    </div>
  );
}
